@if (enableMembers) {
  <app-member-bar></app-member-bar>
}
@if (!isDagrofa) {
  <header>
    <div class="shipping">
      @if (!storeClosed && !isKiosk) {
        <app-icon-button [icon]="shippingIcon" id="menu" (click)="openShippingMenu()"></app-icon-button>
        <label for="menu">{{ shippingLabel }}</label>
      }
    </div>
    <app-icon-button [icon]="closeIcon" (click)="close()"></app-icon-button>
  </header>
}
@if (isDagrofa) {
  <div class="controls">
    <button class="unstyled-button close" (click)="close()">
      <mat-icon [svgIcon]="closeIcon"></mat-icon>
      <span>luk</span>
    </button>
    <a [routerLink]="customerServiceUrl" (click)="close()" class="store">
      <mat-icon svgIcon="support"></mat-icon>
      <span class="notranslate label">Kundeservice</span>
    </a>
    @if (findShopUrl && !isKiosk) {
      <a [href]="findShopUrl" target="_blank" class="store">
        <mat-icon svgIcon="location"></mat-icon>
        <span class="notranslate label">{{ store }}</span>
      </a>
    }
    @if (!findShopUrl || isKiosk) {
      <div target="_blank" class="store">
        <mat-icon svgIcon="location"></mat-icon>
        <span class="notranslate label">{{ store }}</span>
      </div>
    }
  </div>
  <header>
    <div class="shipping">
      @if (!storeClosed) {
        <button class="unstyled-button shipping" (click)="openShippingMenu()">
          @let shippingValid = shippingValid$ | async;
          <mat-icon svgIcon="shop"></mat-icon>
          @if (!shippingValid) {
            VÆLG: DATO & TID
          }
          @if (shippingValid) {
            @let shipping = shipping$ | async;
            {{ shipping.date.toJSDate() | date: 'dd/MM/yy' }} Kl. {{ shipping.time.period }}
          }
        </button>
      }
    </div>
  </header>
}

<div class="menu">
  <div class="title line">
    <h2>{{ title | titlecase }}</h2>
  </div>

  @if (!hideCategories) {
    <div class="categories">
      <ul>
        @if (!childCategories) {
          <li class="category-header menu-link">
            <a class="unstyled-link line" [routerLink]="groceries.url" (click)="close()">{{ groceries.name | titlecase }}</a>
          </li>

          @if (currentCategories) {
            @for (category of currentCategories; track category.data.id) {
              <li class="child-category">
                <button class="unstyled-button line" (click)="selectCategory(category)">
                  {{ category.data.name }}
                </button>
              </li>
            }
          }
        }

        @if (childCategories) {
          <li class="category-header">
            <button class="unstyled-button line" (click)="selectCategory(parentCategory)">
              <mat-icon svgIcon="left_expand_arrow"></mat-icon>
              <h3>{{ currentCategories[0].data.name }}</h3>
            </button>
          </li>

          @if (currentCategories) {
            <li class="current-category single">
              <a class="line" [routerLink]="getCategoryUrl(currentCategories[0].data.id)" queryParamsHandling="merge" (click)="close()">
                Se alle
              </a>
            </li>
          }

          @for (category of childCategories; track category.data.id) {
            <li class="child-category">
              @if (category.children.length > 0) {
                <button class="unstyled-button line" (click)="selectCategory(category)">
                  {{ category.data.name | titlecase }}
                </button>
              }

              @if (category.children.length < 1) {
                <a class="line" [routerLink]="getCategoryUrl(category.data.id)" queryParamsHandling="merge" (click)="close()">
                  {{ category.data.name | titlecase }}
                </a>
              }
            </li>
          }
        }
      </ul>
    </div>
  }

  @if (!childCategories) {
    <div class="links">
      <ul>
        @for (link of links; track $index) {
          <li>
            @if (link.type === 'link') {
              @let sameSiteLink = sameSite(link);
              @if (sameSiteLink) {
                <a
                  class="line"
                  [routerLink]="sameSiteLink.targetUrl"
                  routerLinkActive="active"
                  [target]="sameSiteLink.new ? '_blank' : '_self'"
                  (click)="close()"
                >
                  {{ sameSiteLink.titleText | titlecase }}
                </a>
              }
              @if (!sameSiteLink) {
                <a class="line" [href]="link.targetUrl" [target]="link.new ? '_blank' : '_self'" (click)="close()">
                  {{ link.titleText | titlecase }}
                </a>
              }
            }

            @if (link.type === 'subNav' || link.type === 'burger' || link.type === 'categoryBurger') {
              <div class="sub-navigation line">
                <a
                  [class.no-arrow]="!link.showContentPage"
                  [routerLink]="link.link ? [link.link] : []"
                  [target]="link.linkTarget"
                  (click)="link.link && close()"
                >
                  {{ link.title | titlecase }}
                </a>
                @for (link of link.pages; track $index) {
                  @let sameSiteLink = sameSite(link);
                  @if (sameSiteLink) {
                    <a
                      class="nav small samesite left"
                      [routerLink]="sameSiteLink.targetUrl"
                      [target]="sameSiteLink.new ? '_blank' : '_self'"
                      (click)="close()"
                    >
                      {{ sameSiteLink.titleText }}
                    </a>
                  }
                  @if (!sameSiteLink) {
                    <a class="nav small" [href]="link.targetUrl" [target]="link.new ? '_blank' : '_self'" (click)="close()"
                      >{{ link.titleText }}
                    </a>
                  }
                }
              </div>
            }
          </li>
        }
      </ul>
    </div>
  }
</div>
